// @flow
export const LanguageEN = 'en';
export const LanguageES = 'es';
export const LanguageFR = 'fr';
export const languages = [
  LanguageEN,
  LanguageES,
  LanguageFR,
];
